import { useTranslation } from "react-i18next";import React, { useState } from 'react';
import { Bell, Check, Trash2, Filter } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Card, CardContent } from '@/shared/components/ui/card';
import { Badge } from '@/shared/components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { formatDateTime } from '@/shared/utils';

export const Notifications = () => {const { t } = useTranslation("ezparcel");
  const [notifications, setNotifications] = useState([]);

  const unreadCount = notifications.filter((n) => !n.read).length;

  const markAsRead = (id) => {
    setNotifications(notifications.map((n) =>
    n.id === id ? { ...n, read: true } : n
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, read: true })));
  };

  const deleteNotification = (id) => {
    setNotifications(notifications.filter((n) => n.id !== id));
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t("notifications", "Notifications")}</h1>
          <p className="text-muted-foreground mt-2">{t("stayUpdatedWith", "Stay updated with alerts, exceptions, and system updates")}

          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={markAllAsRead}>
            <Check className="mr-2 h-4 w-4" />{t("markAllRead", "Mark All Read")}

          </Button>
          <Button variant="outline">
            <Filter className="mr-2 h-4 w-4" />{t("filter", "Filter")}

          </Button>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-4">
        <Card className="card-elevated">
          <CardContent className="p-6">
            <div className="flex items-center gap-3 mb-2">
              <Bell className="h-5 w-5 text-muted-foreground" />
              <p className="text-sm font-medium text-muted-foreground">{t("total", "Total")}</p>
            </div>
            <p className="text-3xl font-bold">{notifications.length}</p>
          </CardContent>
        </Card>

        <Card className="card-elevated">
          <CardContent className="p-6">
            <p className="text-sm font-medium text-muted-foreground mb-2">{t("unread", "Unread")}</p>
            <p className="text-3xl font-bold text-[hsl(var(--accent))]">{unreadCount}</p>
          </CardContent>
        </Card>

        <Card className="card-elevated">
          <CardContent className="p-6">
            <p className="text-sm font-medium text-muted-foreground mb-2">{t("warnings", "Warnings")}</p>
            <p className="text-3xl font-bold text-yellow-600">
              {notifications.filter((n) => n.type === 'warning').length}
            </p>
          </CardContent>
        </Card>

        <Card className="card-elevated">
          <CardContent className="p-6">
            <p className="text-sm font-medium text-muted-foreground mb-2">{t("errors", "Errors")}</p>
            <p className="text-3xl font-bold text-red-600">
              {notifications.filter((n) => n.type === 'error').length}
            </p>
          </CardContent>
        </Card>
      </div>

      <Tabs defaultValue="all" className="space-y-4">
        <TabsList>
          <TabsTrigger value="all">{t("allNotifications", "All Notifications")}</TabsTrigger>
          <TabsTrigger value="unread">{t("unread", "Unread (")}{unreadCount})</TabsTrigger>
          <TabsTrigger value="warnings">{t("warnings", "Warnings")}</TabsTrigger>
          <TabsTrigger value="errors">{t("errors", "Errors")}</TabsTrigger>
        </TabsList>

        <TabsContent value="all" className="space-y-3">
          {notifications.map((notification) =>
          <Card key={notification.id} className={`${!notification.read ? 'border-[hsl(var(--accent))]' : ''}`}>
              <CardContent className="p-4">
                <div className="flex items-start gap-4">
                  <div
                  className={`flex h-10 w-10 items-center justify-center rounded-full ${
                  notification.type === 'error' ?
                  'bg-red-100 text-red-600' :
                  notification.type === 'warning' ?
                  'bg-yellow-100 text-yellow-600' :
                  'bg-green-100 text-green-600'}`
                  }>
                  
                    <Bell className="h-5 w-5" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="font-semibold">{notification.title}</h3>
                        <p className="text-sm text-muted-foreground mt-1">{notification.message}</p>
                        <p className="text-xs text-muted-foreground mt-2">
                          {formatDateTime(notification.timestamp)}
                        </p>
                      </div>
                      <div className="flex items-center gap-2">
                        {!notification.read &&
                      <Badge variant="default" className="bg-[hsl(var(--accent))]">{t("new", "New")}</Badge>
                      }
                      </div>
                    </div>
                    <div className="flex gap-2 mt-3">
                      <Button size="sm" variant="outline" onClick={() => markAsRead(notification.id)}>
                        <Check className="h-4 w-4 mr-1" />{t("markRead", "Mark Read")}

                    </Button>
                      <Button size="sm" variant="outline">
                        {notification.action.label}
                      </Button>
                      <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => deleteNotification(notification.id)}>
                      
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </TabsContent>

        <TabsContent value="unread">
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-12">
              <Bell className="h-12 w-12 text-muted-foreground mb-4" />
              <h3 className="text-lg font-semibold mb-2">{t("allCaughtUp", "All caught up!")}</h3>
              <p className="text-muted-foreground text-sm">{t("youHaveNo", "You have no unread notifications")}

              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>);

};